import { createSelector } from 'reselect';
import { addHookActionTypeToReducerFieldMap } from '../reducers/hooks';

export const hasHookSubscription = createSelector(
  (state, name) => [state.hooks, addHookActionTypeToReducerFieldMap[name]],
  ([hooks, name]) => name && Array.isArray(hooks[name]) && hooks[name].length > 0,
);
